import { TextProperty as TextProp } from '../../peregrineFlowInterfaces';
import { Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useState } from 'react';
import VariableAutocompleteTextField from './VariableAutocompleteTextField';

function TextProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as TextProp;
    const [text, setText] = useState<string>(p.value)
    const [changed, setChanged] = useState<boolean>(false);

    const sendOnChanged = useCallback(() => {
        if (!changed)
            return

        p.value = text;
        onChange?.(p)
        setChanged(false);
    }, [onChange, p, setChanged, changed, text]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <VariableAutocompleteTextField
                fullWidth
                value={text}
                variant="outlined"
                description={p.description}
                onValueChange={(v) => { setChanged(true); setText(v); }}
                onBlur={sendOnChanged}
                onKeyDownCapture={(e) => {
                    if (e.key !== "Enter")
                        return

                    sendOnChanged();
                }}
                inputProps={{ maxLength: p.max ? p.max : 256, minLength: p.min ? p.min : 0 }}
            />
        </Box>
    )
}

export default TextProperty;
